import HomeIcon from "@mui/icons-material/Home";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconHomeProps {
  noMargin?: boolean;
  tooltip?: string;
}

export const ListStateIconHome = (props: ListStateIconHomeProps) => (
    <ListStateIcon
        noMargin={props.noMargin}
        tooltip={props.tooltip}
        icon={HomeIcon}
    />
);
